import {
  BodyPostStreetviewHouseholdData, DynamicFilterRequest, FilterRequest,
} from '../../api-models';
import { DynamicFilters } from '../../types/enums';
import { SelectedFilters } from '../../types/filters.type';

const adaptFilterRequest = (
  currentFilters: SelectedFilters,
): BodyPostStreetviewHouseholdData => {
  const adaptedFilters: FilterRequest[] = [];
  const dynamicAdaptedFilters: DynamicFilterRequest[] = [];

  const dynamicFilterNames: string[] = Object.values(DynamicFilters);

  Object.entries(currentFilters).forEach(([, filters]) => {
    Object.entries(filters).forEach(([filterName, filterValues]) => {
      if (dynamicFilterNames.includes(filterName)) {
        dynamicAdaptedFilters.push({
          filter_name: filterName,
          filter_value_list: filterValues.selectedValues.map((value) => value.displayName),
        });
      } else {
        adaptedFilters.push({
          filter_name: filterName,
          filter_value_list: filterValues.selectedValues.map((value) => value.id),
        });
      }
    });
  });

  return {
    filter_request_list: adaptedFilters,
    dynamic_filter_request_list: dynamicAdaptedFilters,
  };
};

export default adaptFilterRequest;
